import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { resolveLang } from '../../utils/resolveLang';

import Section from '../shared/Section';
import EventCard from './EventCard';
import { EventsDataRoot, EventsDataSet } from './types/EventsData';
import { Linkedin } from 'react-feather';

import './event.css';
import ImageLoader from '../shared/loader/ImageLoader';

const Events = (): React.JSX.Element => {

    const { t } = useTranslation();
    const { lang: urlLang } = useParams<{ lang: string }>();
    const [loading, setLoading] = React.useState(false);
    const [events, setEvents] = React.useState<EventsDataSet>();
    const loaders = Array(3).fill(0);

    React.useEffect(() => {
        const lang = resolveLang(urlLang);
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await fetch(`/event?lang=${lang}`);
                if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);

                const data: EventsDataRoot = await response.json();

                if (!data.data || !Array.isArray(data.data)) {
                    setEvents({ upcoming: [], past: [] });
                    setLoading(false);
                    return;
                }
                const now = new Date();
                const upcoming = data.data.filter(w => new Date(w.eventStart) > now);
                const past = data.data.filter(w => new Date(w.eventStart) <= now);
                setEvents({ upcoming, past });
            } catch (err) {
                console.error("Erreur lors de la récupération des events :", err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [t, urlLang]);

    return <>
        <Section className='event-header-section'>
            <Row className='event-header-section py-4'>
                <Col lg={2} style={{ minHeight: 150 }}>
                    <div className='sevent-sidebar'>
                        <div className="sevent-content">
                            <a href="https://www.linkedin.com/company/flowly1/" target="_blank" rel="noreferrer">
                                <span className="sevent-sidebar"><Linkedin size="18" /></span>
                                <span className="sevent-divider"></span>
                                <span className="sevent-text">{t("NavBar.FollowUs")}</span>
                            </a>
                        </div>
                    </div>
                </Col>
                <Col lg={10} xs={12} style={{ zIndex: 98, minHeight: 150 }}>
                    <h2 className="title" dangerouslySetInnerHTML={{ __html: t('Pages.Events.Title')! }}></h2>
                </Col>
            </Row>
        </Section>
        <Section className='event-section'>
            <Row className='container'>
                <Col xs={12} className="category">
                    <h5 dangerouslySetInnerHTML={{ __html: t('Pages.Events.IncomingEvent')! }}></h5>
                </Col>
                <Row className="events-container">

                    {loading && loaders.map((loader, index) =>
                        <Col key={index} xs={12} md={6} xl={4} style={{ height: "300px", padding: "0.75em", zIndex: 98, }}>
                            <ImageLoader />
                        </Col>
                    )}
                    {!loading && events?.upcoming.map((data, index) => (
                        <Col key={index} xs={12} md={6} xl={4} style={{ marginBottom: "1.5rem", }}>
                            <EventCard events={data} />
                        </Col>
                    ))}
                </Row>
                <Col xs={12} className="category">
                    <div className="divider"></div>
                </Col>
                <Col xs={12} className="category">
                    <h5 dangerouslySetInnerHTML={{ __html: t('Pages.Events.PastEvent')! }}></h5>
                </Col>
                <Row className="events-container">

                    {loading && loaders.map((loader, index) =>
                        <Col key={index} xs={12} md={6} xl={4} style={{ height: "300px", padding: "0.75em", zIndex: 98, }}>
                            <ImageLoader />
                        </Col>
                    )}
                    {!loading && events?.past.map((data, index) => (
                        <Col key={index} xs={12} md={6} xl={4} style={{ marginBottom: "1.5rem", }}>
                            <EventCard events={data} />
                        </Col>
                    ))}
                </Row>
            </Row>
        </Section>
    </>
};

export default Events;